/** @jsx jsx */
import { jsx, css, Global } from '@emotion/core';
import { ThemeProvider } from 'emotion-theming';
import { Fragment } from 'react';
import { render } from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AppProviders from '~context';
import 'antd/dist/antd.css';

const dan = localStorage.getItem('dan');

const theme = {
  colors: {
    cardBackground: 'white',
  },
};

const style = css`
  html,
  body,
  #root,
  .app {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-family: 'Open Sans', 'Arial', sans-serif;
    color: #0a2336;
    /* background-color: lightslategrey; */
    /* background-color: #5f6679; */
    /* background-color: #364760; */
    background-color: #eeeff3;
    /* background-color: #bdbdbd; */
    /* background-color: #82b3c9; */
  }
  a {
    color: #0a2336;
    text-decoration: none;
  }
  ${!!dan &&
    `.ant-btn-primary {
    background-color: rgb(0, 155, 142);
    border-color: rgb(0, 155, 142);
  }`}
`;

render(
  <Fragment>
    <Global styles={style} />
    <ThemeProvider theme={theme}>
      <AppProviders>
        <App />
      </AppProviders>
    </ThemeProvider>
  </Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
